import React, {Component} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import webio from '../../services/webio';

export default class Vagas extends Component{
   // executa após o componente ser ativado
   componentDidMount (){
      this.loadDados();
   }

   // carrega os dados da api... promisse
   loadDados = async () =>{
      const {data} = await webio.get('/vagas');
      this.setState({ dados: data });
   }

     // armazena os dados no estado
     state = {
      dados: [],
   }
   // renderiza o componente 
   render(){
      return ( 
         <div className="my-5">
            <h2>Últimas Vagas</h2><hr />
            <Link to="/vagas">
               <small>veja +</small>
            </Link>
               <Row className="mt-sm-5 mt-2">
                  { this.state.dados.length > 0 && this.state.dados.slice(0,6).map ( dado => (
                     <Col sm={4} className="text-left" key = {dado.id}>
                        
                        <Card bg="primary" text="white" border="dark" className="mb-4">
                           <Card.Body>
                              <Card.Text>
                                 <h5>{dado.titulo}</h5>
                                 Quantidade de Vagas: {dado.quantidade_vagas}
                              </Card.Text>
                           </Card.Body>
                        </Card>

                     </Col>
                  )) }
               </Row>
         </div>
      )
   }
}